/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.unifiedaccount.rpc.AccountRpc
 */

export let ComHubspotUnifiedAccountApiModelsAccountDeleteaccountDeleteAccountErrorIF;
(function (_ComHubspotUnifiedAccountApiModelsAccountDeleteaccountDeleteAccountErrorIF) {})(ComHubspotUnifiedAccountApiModelsAccountDeleteaccountDeleteAccountErrorIF || (ComHubspotUnifiedAccountApiModelsAccountDeleteaccountDeleteAccountErrorIF = {}));
export let ComHubspotUnifiedAccountApiModelsAccountListaccountsforappListAccountsForAppErrorIF;
(function (_ComHubspotUnifiedAccountApiModelsAccountListaccountsforappListAccountsForAppErrorIF) {})(ComHubspotUnifiedAccountApiModelsAccountListaccountsforappListAccountsForAppErrorIF || (ComHubspotUnifiedAccountApiModelsAccountListaccountsforappListAccountsForAppErrorIF = {}));
export let ComHubspotUnifiedAccountApiModelsAccountUninstallappUninstallAppErrorIF;
(function (_ComHubspotUnifiedAccountApiModelsAccountUninstallappUninstallAppErrorIF) {})(ComHubspotUnifiedAccountApiModelsAccountUninstallappUninstallAppErrorIF || (ComHubspotUnifiedAccountApiModelsAccountUninstallappUninstallAppErrorIF = {}));
export let ComHubspotUnifiedAccountApiModelsAccountVerifyaccountVerifyAccountErrorIF;
(function (_ComHubspotUnifiedAccountApiModelsAccountVerifyaccountVerifyAccountErrorIF) {})(ComHubspotUnifiedAccountApiModelsAccountVerifyaccountVerifyAccountErrorIF || (ComHubspotUnifiedAccountApiModelsAccountVerifyaccountVerifyAccountErrorIF = {}));
export const deleteAccountRpc = {
  serviceName: 'com.hubspot.unifiedaccount.rpc.AccountRpc',
  rpcName: 'deleteAccount',
  auth: 'app',
  fingerprint: '9HaU0AlvAmHfLB0x2FUSFJcPwYN1NqAH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listAccountsForAppRpc = {
  serviceName: 'com.hubspot.unifiedaccount.rpc.AccountRpc',
  rpcName: 'listAccountsForApp',
  auth: 'app',
  fingerprint: 'xJVkD3SziOG0-WNDWCNTBiSumAktl8wr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const uninstallAppRpc = {
  serviceName: 'com.hubspot.unifiedaccount.rpc.AccountRpc',
  rpcName: 'uninstallApp',
  auth: 'app',
  fingerprint: 'ajdF8-3Y4IR5G50dc_33gXf0_OMNK_li',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const verifyAccountRpc = {
  serviceName: 'com.hubspot.unifiedaccount.rpc.AccountRpc',
  rpcName: 'verifyAccount',
  auth: 'app',
  fingerprint: 'J5COPZAUAOQeO4ZaOIO67Vha5q8QZSqD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};